import { render, staticRenderFns } from "./MfNotice.vue?vue&type=template&id=46f7ba80&scoped=true"
import script from "./MfNotice.vue?vue&type=script&lang=js"
export * from "./MfNotice.vue?vue&type=script&lang=js"
import style0 from "./MfNotice.vue?vue&type=style&index=0&id=46f7ba80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7ba80",
  null
  
)

export default component.exports